import enumList from './enumList';

Number.prototype.isSuccessCode = function() {
  return String(this) === enumList.httpStatusCode.successCode; // api 成功代碼
};

export {};
